import * as React from 'react';
import { AppointmentController } from 'api';
import errorReporter from '@app/errorReporter';

// TODO: Type me to DTO
interface ExclusivesDataType {
  id: string;
  line1: string;
  line2: string;
  location: string;
  reps: {
    id: string;
    firstName: string;
    lastName: string;
  }[];
  documentSubmission: {
    userName: string;
    userId: string;
    date: Date;
  };
}

interface UseGetExclusivesQueueProps {
  locationIndices?: string[];
  isAuthorized: boolean;
  setExclusivesCount: (exCount: number) => void;
}
interface UseGetExclusivesQueueType {
  sort: (key: SortKeys) => void;
  data: ExclusivesDataType[];
  pageHandler: (page: number) => void;
  totalCount: number;
  isLoading: boolean;
  query: { page: number };
}

type SortKeys = 'line1' | 'location' | 'date';

const useGetExclusivesQueue = ({
  locationIndices,
  isAuthorized,
  setExclusivesCount,
}: UseGetExclusivesQueueProps): UseGetExclusivesQueueType => {
  const [totalCount, setTotalCount] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(false);

  const [query, setQuery] = React.useState<{
    sortDirection: number;
    sortBy: SortKeys;
    page: number;
    locationIndices?: string[];
  }>({ sortDirection: -1, sortBy: 'date', page: 1, locationIndices });
  const [data, setData] = React.useState<ExclusivesDataType[]>([]);

  React.useEffect(() => {
    const fetchExclusives = async () => {
      try {
        setIsLoading(true);
        const { data: exclusives, count } = await AppointmentController.findOrg(
          {
            requestType: 'exclusives',
            query,
          },
        );
        setData(exclusives);
        setTotalCount(count);
        setExclusivesCount(count);
      } catch (err) {
        errorReporter.error('error fetching pending exclusives', err);
      } finally {
        setIsLoading(false);
      }
    };
    if (isAuthorized) fetchExclusives();
  }, [
    query.sortDirection,
    query.sortBy,
    query.page,
    query.locationIndices,
    isAuthorized,
  ]);

  React.useEffect(() => {
    if (isAuthorized) setQuery(prev => ({ ...prev, locationIndices }));
  }, [locationIndices]);

  const sort = (sortBy: SortKeys) => {
    if (sortBy === query.sortBy) {
      setQuery(prev => ({ ...prev, sortDirection: prev.sortDirection * -1 }));
    } else setQuery(prev => ({ ...prev, sortDirection: 1, sortBy }));
  };

  const pageHandler = (page: number) => {
    setQuery(prev => ({ ...prev, page }));
  };

  return { sort, data, isLoading, pageHandler, totalCount, query };
};

export default useGetExclusivesQueue;
